var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "video-wrapper relative w-full h-full flex justify-center align-center",
    },
    [
      _vm.videoType === "youtube"
        ? _c("youtube", {
            ref: "youtube",
            staticClass: "video-wrapper__video w-full h-full",
            class: _vm.classes,
            attrs: {
              "video-id": _vm.videoId,
              "player-vars": _vm.options,
              controls: "0",
            },
            on: {
              ready: _vm.onReady,
              playing: _vm.onPlaying,
              paused: _vm.onPaused,
            },
          })
        : _vm.videoType === "vimeo"
        ? _c("vimeo", {
            ref: "vimeo",
            staticClass: "video-wrapper__video w-full h-full",
            class: _vm.classes,
            attrs: {
              options: _vm.options,
              "video-id": _vm.videoId,
              controls: false,
            },
            on: {
              ready: _vm.onReady,
              play: _vm.onPlaying,
              pause: _vm.onPaused,
            },
          })
        : _c(
            "video",
            {
              ref: "htmlVideo",
              staticClass: "video-wrapper__video object-contain",
              class: [{ lozad: _vm.isLazyLoaded }, _vm.classes],
              attrs: {
                disableremoteplayback: "",
                nodownload: "",
                muted: "",
                playsinline: "",
                controlsList: "nodownload",
                disablePictureInPicture: "",
                autoplay: _vm.isAutoplay,
                loop: _vm.isLoop,
                "data-poster": _vm.thumbnail,
              },
              domProps: { muted: true },
              on: {
                play: _vm.onPlaying,
                pause: _vm.onPaused,
                canplay: _vm.onReady,
              },
            },
            [
              _vm._l(_vm.sources, function (videoUrl) {
                return _c("source", {
                  key: videoUrl,
                  ref: "htmlVideoSource",
                  refInFor: true,
                  attrs: { type: "video/mp4" },
                })
              }),
              _vm._v(" "),
              _c("img", {
                ref: "htmlVideoThumbnail",
                attrs: { alt: _vm.thumbnailAlt },
              }),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mask absolute flex items-center justify-center cursor-pointer",
          on: {
            click: function ($event) {
              return _vm.togglePlay()
            },
          },
        },
        [
          !_vm.isPlaying && !_vm.isLoading
            ? _c(
                "svg",
                {
                  attrs: {
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "64",
                    height: "64",
                    viewBox: "0 0 32 32",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      "fill-rule": "evenodd",
                      d: "M16 2c7.732 0 13.999 6.268 13.999 14s-6.267 14-14 14C8.269 30 2 23.732 2 16S8.268 2 16 2zm-1.547 9.819c-.833-.51-1.917.069-1.917 1.022v6.318c0 .943 1.063 1.523 1.895 1.035l5.273-3.09c.794-.466.805-1.578.02-2.058z",
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "mask mask--loading" }, [
            _c("span", { staticClass: "spinner" }, [_vm._v("Loading")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }